export default __webpack_public_path__ + "static/media/box2-ar.2d31279a.svg";